import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import React, { useEffect, useRef, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { brandText } from '../../../../../config/branding';
import DefaultApiLimit from '../../../../../config/defaultLimit';
import DefaultApiParameters from '../../../../../enum/DefaultApiParameters';
import currentTimeZone from '../../../../../enum/timeZone';
// import { ToggleListProperties } from '../../../../interface/device-management.interface';
import {
  DeviceTransactionProperties,
  DeviceTransactionRequest,
} from '../../../../../interface/device-transactions.interface';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  fetchDeviceTransaction,
  fetchListTransactionFilters,
  updateTransactionFilters,
  setSortData,
  refreshDeviceTransaction,
} from '../../../../../redux/slices/DeviceTransactionSlice';
import { setNotificationMessage } from '../../../../../redux/slices/NotificationManagementSlice';
import { setSidePanelData } from '../../../../../redux/slices/TableSidePanelSlice';
import CustomDateRangePicker from '../../../../../shared-components/custom-date-range/CustomDateRangePicker';
import CustomTable from '../../../../../shared-components/custom-table/CustomTable';
// import DurationToggle from '../../../../shared-components/duration-toggle/DurationToggle';
import { useTableSidePanel } from '../../../../../shared-components/table-side-panel/hooks/useTableSidePanel';
import StationSidePanel from '../../../../../shared-components/table-side-panel/StationSidePanel';
import { GetParametersFromCommonFilters } from '../../../../../shared-functions/CommonFilters';
import ConvertUTCtoDateTime from '../../../../../shared-functions/ConvertUTCtoDateTime';
import { removeEmptyKeys } from '../../../../../shared-functions/DateTime';
import { exportCSV, exportPDF } from '../../../../../shared-functions/ExportFile';
import ToFixedValue from '../../../../../shared-functions/ToFixedValue';
import cpoTransactionApi from '../../../../../utils/api/cpo-transaction';
import device from '../../../../../utils/api/device';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

interface ChartDataProperties {
  year?: number;
  month?: string;
  date: string;
  hour: number;
  label?: string;
  totalPowerConsumed: number;
  totalDebitAmount: number;
}

/**
 * Function to fill missing months in chart
 * @param {any} data - The data
 * @returns {any} The result
 */
// function fillMissingMonths(data: ChartDataProperties[]) {
//   const today = new Date();
//   const months = [
//     'Jan',
//     'Feb',
//     'Mar',
//     'Apr',
//     'May',
//     'Jun',
//     'Jul',
//     'Aug',
//     'Sep',
//     'Oct',
//     'Nov',
//     'Dec',
//   ];

//   // Generate past 12 months dynamically
//   const past12Months = [];
//   for (let index = 0; index < 12; index += 1) {
//     const date = new Date(today.getFullYear(), today.getMonth() - index, 1); // Get the first day of the month
//     past12Months.push({
//       label: months[date.getMonth()], // Month name
//       year: date.getFullYear(), // Year
//     });
//   }

//   // Map input data for easy lookup
//   const totalPowerConsumedMap = new Map(data.map((item) => [item.month, item.totalPowerConsumed]));
//   const totalDebitAmountMap = new Map(data.map((item) => [item.month, item.totalDebitAmount]));

//   // Generate result array with missing months filled
//   const result = past12Months.map(({ label, year }) => {
//     const key = label; // Use the month name as key
//     return {
//       hour: 0,
//       date: '',
//       label: `${label} ${year}`, // Combine month and year for output
//       totalPowerConsumed: totalPowerConsumedMap.get(key) || 0, // Default to 0 if month is missing
//       totalDebitAmount: totalDebitAmountMap.get(key) || 0, // Default 0
//     };
//   });

//   return result.reverse();
// }

/**
 * Function to generate the map data for past 30 days
 * @param {any} data - The data
 * @returns {any} The result
 */
// function fillMissingLastMonth(data: ChartDataProperties[]) {
//   const today = new Date();
//   const past30Days = [];

//   // Generate the past 30 days as ISO date strings
//   for (let index = 0; index < 30; index += 1) {
//     const date = new Date(today);
//     date.setDate(today.getDate() - index);
//     const isoDate = date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
//     past30Days.push({ date, isoDate });
//   }

//   // Map input data using full ISO date for lookup
//   const totalPowerConsumedMap = new Map(
//     data.map((item) => [item.date.split('T')[0], item.totalPowerConsumed]),
//   );
//   const totalDebitAmountMap = new Map(
//     data.map((item) => [item.date.split('T')[0], item.totalDebitAmount]),
//   );

//   // Date formatter to get "Mar 18" format
//   const dateFormatter = new Intl.DateTimeFormat('en-US', {
//     month: 'short',
//     day: 'numeric',
//   });

//   // Build the result array
//   const result = past30Days.map(({ date, isoDate }) => ({
//     hour: 0,
//     date: dateFormatter.format(date),
//     label: dateFormatter.format(date), // Format label as "Mar 18"
//     totalPowerConsumed: totalPowerConsumedMap.get(isoDate) || 0, // Default to 0
//     totalDebitAmount: totalDebitAmountMap.get(isoDate) || 0, // Default to 0
//   }));

//   return result.reverse();
// }

/**
 * Function to add missing data in last 7 days
 * @param {any} data - The data
 * @returns {any} The result
 */
// function fillMissingLast7Days(data: ChartDataProperties[]) {
//   const today = new Date();
//   const last7Days = [];

//   // Generate the last 7 days as ISO date strings
//   for (let index = 0; index < 7; index += 1) {
//     const date = new Date(today);
//     date.setDate(today.getDate() - index);
//     last7Days.push(date);
//   }

//   // Map input data using full ISO date for lookup
//   const totalPowerConsumedMap = new Map(
//     data.map((item) => [item.date.split('T')[0], item.totalPowerConsumed]),
//   );
//   const totalDebitAmountMap = new Map(
//     data.map((item) => [item.date.split('T')[0], item.totalDebitAmount]),
//   );
//   // Date formatter to get "Nov 14" format
//   const dateFormatter = new Intl.DateTimeFormat('en-US', {
//     month: 'short',
//     day: 'numeric',
//   });

//   // Build the result array
//   const result = last7Days.map((date) => {
//     const isoDate = date.toISOString().split('T')[0]; // Use ISO date for lookup
//     return {
//       hour: 0,
//       date: dateFormatter.format(date),
//       label: dateFormatter.format(date), // Format label as "Mar 18"
//       totalPowerConsumed: totalPowerConsumedMap.get(isoDate) || 0, // Default to 0
//       totalDebitAmount: totalDebitAmountMap.get(isoDate) || 0, // Default to 0
//     };
//   });

//   return result.reverse();
// }

/**
 * Function to handle missing data for the last 24 hours based on the current time zone
 * @param {any} data - The input data
 * @returns {any} The result with complete data for the last 24 hours
 */
// function fillMissingLast24HrsData(data: ChartDataProperties[]) {
//   const now = new Date();
//   const past24Hours = [];

//   for (let index = 0; index < 24; index += 1) {
//     const date = new Date(now);
//     date.setHours(now.getHours() - index, 0, 0, 0); // Adjust hour, reset minutes/seconds/ms

//     // Format date and hour based on the specified time zone
//     const formatter = new Intl.DateTimeFormat('en-CA', {
//       timeZone: currentTimeZone,
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//       hour: '2-digit',
//       hourCycle: 'h23', // Ensures 0-23 hour format
//     });

//     const formattedDate = formatter.formatToParts(date);
//     const year = formattedDate.find((p) => p.type === 'year')?.value;
//     const month = formattedDate.find((p) => p.type === 'month')?.value;
//     const day = formattedDate.find((p) => p.type === 'day')?.value;
//     const hour = formattedDate.find((p) => p.type === 'hour')?.value;

//     // Ensure YYYY-MM-DD format
//     const isoDate = `${year}-${month}-${day}`;

//     past24Hours.push({ date: isoDate, hour: Number(hour) });
//   }

//   // Build the result array
//   const result = past24Hours.map((eachHour) => {
//     const dataForHour = data.find(
//       (eachData) => eachData.date === eachHour.date && eachData.hour === eachHour.hour,
//     );

//     return {
//       hour: 0,
//       date: '',
//       label: eachHour.hour.toString(), // Hour (0-23)
//       totalPowerConsumed: dataForHour ? dataForHour.totalPowerConsumed : 0, // Default to 0 if data not found
//       totalDebitAmount: dataForHour ? dataForHour.totalDebitAmount : 0, // Default to 0 if data not found
//     };
//   });

//   return result.reverse(); // Ensuring chronological order
// }

/**
 * Transaction component
 * @returns {any} The result
 */
function Transactions() {
  const { t } = useTranslation('devices');
  const dispatch = useAppDispatch();
  const {
    transactions,
    limit,
    page,
    loading,
    totalPages,
    totalResults,
    filterListLoading,
    filters,
    sortField,
    sortBy,
  } = useAppSelector((s) => s.deviceTransaction);
  const { selectedChargingPoint } = useAppSelector((s) => s.device);

  const [powerConsumedRevenue, setPowerConsumedRevenue] = useState<ChartDataProperties[]>([]);
  const [exportLoader, setExportLoader] = useState<boolean>(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [searchParameters, setSearchParameters] = useSearchParams();

  /**
   * Function to refresh data
   */
  const handleRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    dispatch(
      fetchDeviceTransaction({
        page,
        limit,
        sortBy,
        sortField,
        chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
        ...queryParameters,
      }),
    );
  };

  const { isEditMode, handleEditModeChange, handleSidePanelClose, renderSidePanelTopLeftContent } =
    useTableSidePanel({
      onRefresh: handleRefresh,
      sessions: transactions,
    });

  /** Draws the vertical crosshair line using the theme's success color on hover */
  const verticalHoverLinePlugin = {
    id: 'verticalHoverLine',
    /**
     * Draws a success-colored vertical crosshair line at the hovered x position.
     * @param {any} chart - The Chart.js instance
     */
    afterDraw(chart: any) {
      if (chart.tooltip?._active?.length) {
        const context = chart.ctx as CanvasRenderingContext2D;
        const { x } = chart.tooltip._active[0].element;
        const { top, bottom } = chart.chartArea;

        const successColor = getComputedStyle(document.documentElement)
          .getPropertyValue('--success')
          .trim();

        context.save();
        context.beginPath();
        context.moveTo(x, top);
        context.lineTo(x, bottom);
        context.lineWidth = 1;
        context.strokeStyle = successColor || '#2E9E3A';
        context.stroke();
        context.restore();
      }
    },
  };

  const lineChartContainerReference = useRef<HTMLDivElement>(null);
  const [lineChartSize, setLineChartSize] = useState({
    width: 0,
    height: 0,
  });

  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: '',
  });

  const column = [
    {
      label: t('stationId'),
      accessorKey: 'stationId' as keyof DeviceTransactionProperties,
      sortAllow: true,
      queryParamsKey: 'stationId',
      queryParamsValue: 'stationId',
      sidePanelComponent: (
        <StationSidePanel
          fetchIdFrom="queryParams"
          initialIsEditMode={isEditMode}
          onEditModeChange={handleEditModeChange}
          onSuccess={() => {
            handleEditModeChange(false);
            handleRefresh();
          }}
        />
      ),
      disableNewTab: true,
      /**
       * Custom station data renderer with side panel open handler
       * @param {DeviceTransactionProperties} currentRow - The currentRow
       * @returns {any} The result
       */
      customData: (currentRow: DeviceTransactionProperties) => {
        const stationId =
          currentRow.cdrLocation?.id ||
          (typeof (currentRow as any).chargingStation === 'object'
            ? (currentRow as any).chargingStation?._id || (currentRow as any).chargingStation?.id
            : (currentRow as any).chargingStation) ||
          (currentRow as any).stationId ||
          (currentRow as any).chargingStationId;

        return (
          <span
            className={`table-row-each-data ${stationId ? 'hyperlink' : ''}`}
            role="presentation"
            onClick={(event) => {
              event.stopPropagation();
              if (!stationId) return;
              const parameters = new URLSearchParams(searchParameters);
              const sidePanelKeys = [
                'deviceId',
                'connectorDeviceId',
                'stationId',
                'facilityId',
                'userCustomId',
                'userId',
                'utilityId',
                'transactionObjectId',
                'roleId',
                'sessionId',
                'cdrObjectId',
                'paymentDetailsId',
                'personalChargerId',
                'action',
              ];
              sidePanelKeys.forEach((key) => parameters.delete(key));
              parameters.set('stationId', stationId);
              setSearchParameters(parameters);
              dispatch(
                setSidePanelData({
                  key: 'Transactions',
                  value: currentRow.id || currentRow._id,
                }),
              );
            }}>
            {currentRow.cdrLocation?.id || '-'}
          </span>
        );
      },
    },
    {
      label: t('connector'),
      accessorKey: 'connector' as keyof DeviceTransactionProperties,
      sortAllow: true,
      /**
       * Function to show connector in table
       * @param {DeviceTransactionProperties} row - The row
       * @returns {any} The result
       */
      customData: (row: DeviceTransactionProperties) => {
        const connector =
          row?.cdrLocation?.connectorId ??
          row?.cdrLocation?.evseUid ??
          row?.connector ??
          (row as any)?.connectors ??
          '-';
        return <p>{connector}</p>;
      },
    },
    {
      label: t('powerConsumed'),
      accessorKey: 'powerConsumed' as keyof DeviceTransactionProperties,
      sortAllow: true,
      /**
       * Function to show power consumed in table
       * @param {DeviceTransactionProperties} row - The row
       * @returns {any} The result
       */
      customData: (row: DeviceTransactionProperties) => {
        const energy =
          row?.powerConsumed ??
          (row as any)?.totalEnergy ??
          (row as any)?.energyConsumed ??
          (row as any)?.totalPowerConsumed ??
          0;
        return <p>{ToFixedValue(energy, 3)} kWh</p>;
      },
    },
    {
      label: t('amount'),
      accessorKey: 'amount' as keyof DeviceTransactionProperties,
      sortAllow: true,
      /**
       * Function to show amount in table
       * @param {DeviceTransactionProperties} row - The row
       * @returns {any} The result
       */
      customData: (row: DeviceTransactionProperties) => {
        const amount =
          (row as any)?.totalCost?.inclVat ??
          (row as any)?.totalCost?.exclVat ??
          row?.amount ??
          (row as any)?.totalDebitAmount ??
          (row as any)?.totalAmount ??
          0;
        return <p>{ToFixedValue(Number(amount || 0))}</p>;
      },
    },
  ];

  /**
   * Export data function for pdf and csv based on visible columns
   * @param {string} type - Export format ('csv' | 'pdf')
   */
  const exportDataPdfOrCSV = (type: string) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    const sn = selectedChargingPoint?.chargingPointSn;
    const payload: Record<string, any> = {
      ...queryParameters,
    };
    if (sn) {
      payload.chargingPointSn = Array.isArray(sn) ? sn : [sn];
    }
    if (sortBy) payload.sortBy = sortBy;
    if (sortField) payload.sortField = sortField;

    setExportLoader(true);
    cpoTransactionApi
      .fetchCpoTransactionsExport(removeEmptyKeys(payload))
      .then((response: any) => {
        const visibleColumns = column.filter(
          (col) => !hiddenColumns.includes(col.accessorKey as string),
        );

        const headers = [
          t('sNo', 'S.No'),
          ...visibleColumns.map((col) => col.label),
          ...(!hiddenColumns.includes('createdAt') ? [t('created', 'Created')] : []),
          ...(!hiddenColumns.includes('updatedAt') ? [t('lastUpdated', 'Last Updated')] : []),
        ];

        const rows = response.data.map((row: DeviceTransactionProperties, index: number) => [
          index + 1,
          ...visibleColumns.map((col) => {
            const accessor = col.accessorKey as string;
            if (accessor === 'stationId') {
              return (
                row.cdrLocation?.id ||
                (row as any).stationId ||
                (typeof (row as any).chargingStation === 'object'
                  ? (row as any).chargingStation?.name || (row as any).chargingStation?._id
                  : (row as any).chargingStation) ||
                '-'
              );
            }
            if (accessor === 'connector') {
              return (
                row.cdrLocation?.connectorId ??
                row.cdrLocation?.evseUid ??
                (row as any).connector ??
                row.connectors ??
                '-'
              );
            }
            if (
              accessor === 'powerConsumed' ||
              accessor === 'totalEnergy' ||
              accessor === 'energyConsumed'
            ) {
              const energy =
                row.powerConsumed ??
                row.totalEnergy ??
                row.energyConsumed ??
                (row as any).totalPowerConsumed ??
                0;
              return `${ToFixedValue(energy, 3)} kWh`;
            }
            if (accessor === 'amount' || accessor === 'totalCost') {
              const amount =
                row.totalCost?.inclVat ??
                row.totalCost?.exclVat ??
                row.amount ??
                (row as any).totalDebitAmount ??
                (row as any).totalAmount ??
                0;
              return ToFixedValue(Number(amount || 0));
            }
            return (row as any)[accessor] || '-';
          }),
          ...(!hiddenColumns.includes('createdAt')
            ? [ConvertUTCtoDateTime(row.createdAt || (row as any).date) || '-']
            : []),
          ...(!hiddenColumns.includes('updatedAt')
            ? [ConvertUTCtoDateTime((row as any).updatedAt) || '-']
            : []),
        ]);

        setExportLoader(false);
        if (rows.length > 0) {
          if (type === 'csv') {
            exportCSV(headers, rows, 'device-transactions.csv');
          } else {
            exportPDF(headers, rows, 'device-transactions.pdf');
          }
        }
      })
      .catch((error: any) => {
        setExportLoader(false);
        dispatch(
          setNotificationMessage({
            message: error?.response?.data?.message || t('somethingWentWrong'),
            status: true,
            type: 'error',
            code: error?.response?.data?.code,
          }),
        );
      });
  };

  const revenueChartData = {
    labels: powerConsumedRevenue.map((eachData) => eachData.label),
    datasets: [
      {
        label: t('revenue'),
        data: powerConsumedRevenue.map((d) => ToFixedValue(d.totalDebitAmount)),
        borderColor: '#F79009',
        /**
         * Background
         * @param {any} context - The context
         * @returns {any} The result
         */
        backgroundColor: (context: any) => {
          const { chart } = context;
          const contentContext = chart.ctx;
          const gradient = contentContext.createLinearGradient(0, 0, 0, chart.height);
          gradient.addColorStop(0, 'rgba(247, 144, 9, 0.4)');
          gradient.addColorStop(1, 'rgba(237, 237, 237, 0)');
          return gradient;
        },
        fill: 'origin', // Fills to the previous dataset
        tension: 0.4,
        borderWidth: 1,
        pointRadius: 0,
        pointHoverRadius: 4,
      },
    ],
  };

  const powerConsumedChartData = {
    labels: powerConsumedRevenue.map((eachData) => eachData.label),
    datasets: [
      {
        label: t('electricity'),
        data: powerConsumedRevenue.map((d) => ToFixedValue(d.totalPowerConsumed)),
        borderColor: '#2E9E3A',
        /**
         * Function to create a gradient bg color
         * @param {any} context - The context
         * @returns {any} The result
         */
        backgroundColor: (context: any) => {
          const { chart } = context;
          const chartContext = chart.ctx;
          const gradient = chartContext.createLinearGradient(0, 0, 1, chart.height);
          gradient.addColorStop(0, 'rgba(46, 158, 58, 1)');
          gradient.addColorStop(1, 'rgba(237, 237, 237, 0)');
          return gradient;
        },
        fill: 'origin',
        tension: 0.4,
        borderWidth: 1,
        pointRadius: 0, // Remove points on the line
        pointHoverRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: 'top' as const, // Explicitly cast to 'top' to ensure correct type
        align: 'end' as const,
        labels: {
          usePointStyle: true,
          boxWidth: 10,
          boxHeight: 10,
          borderRadius: 10,
          padding: 15,
        },
        padding: {
          right: 500, // Add 50px padding to the right side of the legend
        },
      },
      tooltip: {
        backgroundColor: '#1F2937',
        titleColor: '#FFFFFF',
        bodyColor: '#FFFFFF',
        padding: 10,
        borderRadius: 8,
        cornerRadius: 4,
        displayColors: true,
        callbacks: {
          /**
           * Function to generate to title for chart
           * @param {any} context - The context
           * @returns {any} The result
           */
          title: (context: any) => {
            // Set title based on dataset
            const datasetLabel = context[0]?.dataset?.label;
            return datasetLabel;
          },
          /**
           * Function to show tooltip data
           * @param {any} context - The context
           * @returns {any} The result
           */
          label: (context: any) => {
            // Format the label with currency
            const datasetLabel = context?.dataset?.label;
            return `${context?.raw.toLocaleString()}  ${datasetLabel === t('revenue') ? brandText.currency : 'kWh'}`;
          },
        },
      },
    },

    interaction: {
      intersect: false,
      mode: 'index' as const,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false, // Hides the y-axis line
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          display: false, // Hides the tick labels on the y-axis (revenue and expense values)
        },
        border: {
          display: false, // Hides the y-axis line
        },
      },
    },
  };

  /**
   * Handle the filter data clear function
   * @param {any} sortData - The sortData
   */
  const handleSortFunction = (sortData: any) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    dispatch(setSortData(sortData));
    dispatch(
      fetchDeviceTransaction({
        ...queryParameters,
        sortBy: sortData.sortBy,
        sortField: sortData.sortField,
        page: DefaultApiLimit.page,
        limit,
        chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
      }),
    );
  };

  /**
   * Table pagination function
   * @param {any} value - The value
   */
  const pageNateLimitChange = (value: DeviceTransactionRequest) => {
    dispatch(
      fetchDeviceTransaction({
        ...value,
        sortField,
        sortBy,
        chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
      }),
    );
  };

  /**
   * Handles the auto-refresh functionality for the device transactions.
   * Fetches the latest transaction data based on the current filters and pagination settings.
   */
  const handleAutoRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);

    dispatch(
      refreshDeviceTransaction({
        ...queryParameters,
        page,
        limit,
        sortBy,
        sortField,
        chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
      }),
    );
  };

  /**
   * Function to fetch the transaction report.
   * @param {string} startDate - Report start date.
   * @param {string} endDate - Report end date.
   */
  const handleFetchTransactionReport = async (startDate: string, endDate: string) => {
    try {
      const response = await device.fetchTransactionReport({
        chargingPointSn: selectedChargingPoint?.chargingPointSn,
        timeZone: currentTimeZone,
        startDate,
        endDate,
      });
      setPowerConsumedRevenue(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   handleFetchTransactionReport(
  //     toggleList.find((toggle) => toggle.isActive === true)?.key || 'last24hours',
  //   );
  // }, [toggleList]);

  useEffect(() => {
    const queryParameters = GetParametersFromCommonFilters(filters);

    dispatch(
      fetchDeviceTransaction({
        page: DefaultApiParameters.page,
        limit: DefaultApiParameters.limit,
        chargingPointSn: selectedChargingPoint?.chargingPointSn || '',
        ...queryParameters,
      }),
    );
  }, [filters, selectedChargingPoint]);

  useEffect(() => {
    const width = lineChartContainerReference.current?.offsetWidth || 0;
    const height = lineChartContainerReference.current?.offsetHeight || 0;
    setLineChartSize({
      width: width - 25,
      height,
    });
  }, [lineChartContainerReference.current]);

  return (
    <div className="device-details-transaction-wrap">
      <div className="device-details-transaction-table">
        <CustomTable
          header={column}
          data={transactions}
          serialNo
          filter={{}}
          filterClearFunction={() => {}}
          filterFunction={() => {}}
          actionButton={false}
          limit={limit}
          page={page}
          loading={loading}
          totalPages={totalPages}
          totalResults={totalResults}
          sortData={{ sortBy, sortField }}
          handleSortChange={handleSortFunction}
          pageLimitChange={(value: any) => pageNateLimitChange(value)}
          sizeChangeButtonRequired
          requiredRefreshToggle
          refreshFunction={handleAutoRefresh}
          filters={filters}
          filtersToDispatch={updateTransactionFilters}
          filterListLoading={filterListLoading}
          filterListToDispatch={fetchListTransactionFilters}
          exportDataPdfOrCSV={exportDataPdfOrCSV}
          exportLoader={exportLoader}
          exportData={transactions}
          onHiddenColumnsChange={setHiddenColumns}
          sidePanelTopLeftContent={renderSidePanelTopLeftContent() ?? undefined}
          onSidePanelClose={() => {
            handleSidePanelClose();
          }}
          version="v2"
          height={400}
          created
          lastUpdated
        />
      </div>
      <div className="device-details-container" ref={lineChartContainerReference}>
        {/* <DurationToggle toggleList={toggleList} handleClickFunction={handleClickFunction} /> */}
        <CustomDateRangePicker
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          placeholder="DD-MMM-YYYY - DD-MMM-YYYY"
          onChange={(start, end) => {
            setDateRange({
              startDate: start,
              endDate: end,
            });
            handleFetchTransactionReport(start, end);
          }}
        />
        <div className="chart-container">
          <h6>{t('powerConsumed')}</h6>
          <Line
            data={powerConsumedChartData}
            options={options}
            width={lineChartSize.width}
            height={200}
            plugins={[verticalHoverLinePlugin]}
          />
        </div>
        <div className="chart-container">
          <h6>{t('revenueGraph')}</h6>
          <Line
            data={revenueChartData}
            options={options}
            width={lineChartSize.width}
            height={200}
            plugins={[verticalHoverLinePlugin]}
          />
        </div>
      </div>
    </div>
  );
}

export default Transactions;
